import api from '../../service/api'

const UserLogin = async(data) =>{
	let path = '/login/'
	return api.login(path,data);
}

const SendForgotPasswordLink = async(data) =>{
	let path = '/user/forgot-password/'
	return api.postWithoutJWT(path,data);
}

const renewTokenAPI=async(data)=>{
	let path = '/user/token/refresh/'
	return api.renewToken(path,data)
}

const ForgotPassword = async(fToken, userId, expiryTime, token) =>{
	let path = 'user/forgot-password/?fToken='+fToken+'&userId='+userId+'&expiryTime='+expiryTime+'&token='+token;
	return api.getWithoutJWT(path);
}

const ResetPassword = async(data) => {
	let path = 'user/reset-forgot-password/';
	return api.putWithoutJWT(path,data);
}

const ChangePassword = async(data) => {
	let path = 'user/change-password/';
	return api.put(path,data);
}

const ForceChangePassword = async(data) => {
	let path = 'user/force-change-password/';
	return api.putWithoutJWT(path,data);
}

export default {UserLogin, SendForgotPasswordLink,renewTokenAPI,
	ForgotPassword,ResetPassword,ChangePassword,ForceChangePassword
};